import { render, staticRenderFns } from "./Socket.vue?vue&type=template&id=14172ed0&scoped=true"
import script from "./Socket.vue?vue&type=script&lang=js"
export * from "./Socket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14172ed0",
  null
  
)

export default component.exports